export default __webpack_public_path__ + "static/media/p1.f50db3b1.png";